module.exports = __webpack_public_path__ + "img/四川天府新区红太阳幼儿园.30502780.jpg";